import React from 'react';
import divider from '../../assets/divider.svg';
import { Button } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

import customer1 from '../../assets/customer1.png';
import customer2 from '../../assets/customer2.png';
import customer3 from '../../assets/customer3.png';
import customer4 from '../../assets/customer4.png';
import reviewImage1 from "../../assets/reviewImage1.jpg"
import reviewImage2 from '../../assets/reviewImage2.jpg';
import reviewImage3 from '../../assets/reviewImage3.jpg';
import reviewImage4 from '../../assets/reviewImage4.jpg';

const Customers = () => {
  const data = [
    {
      img: reviewImage1,
      description:
        'I love the designs which are original, beautiful, simple and elegant.',
    },
    {
      img: reviewImage2,
      description: 'Absolutely love the long haram that mukunda made for me.',
    },
    {
      img: reviewImage3,
      description:
        'I love mukunda jewelry. It is so different from anything I can get in hyderabad.',
    },
    {
      img: reviewImage4,
      description:
        'MAGIC! This is the first word that came to my mind when I opened my delivery.',
    },
  ];



  return (
    <div className='flex flex-col bg-white w-full'>
      <h1 className='text-center text-[#010535] font-semibold text-2xl md:text-3xl'>
        Customers Love
      </h1>

      <div className='flex justify-center items-center py-8 gap-3'>
        <div className='border border-x-2 border-[#F4B41A] w-[30%]'></div>
        <img src={divider} />
        <div className='border border-[#F4B41A] w-[30%]'></div>
      </div>

      <div className='flex flex-wrap justify-center gap-8 w-full mx-auto'>
        {data.map((e, i) => (
          <div
            key={i}
            className='flex flex-col items-center text-center p-5 border-[10px] border-[#D3A143CC] rounded-2xl shadow-sm hover:shadow-md transition w-64'
          >
            <img
              src={e.img}
              alt={e.name}
              className='rounded-full object-cover mb-3'
            />
            <p className='text-[#010535] font-semibold text-lg md:text-xl'>
              {e.name}
            </p>
            <p className='text-[#4D4C4C] text-sm md:text-base mt-2'>
              {e.description}
            </p>
          </div>
        ))}
      </div>

      <div className='flex justify-center items-center p-6 gap-3'>
        <div className='hidden md:block border border-[#F4B41A] w-[30%]'></div>
          <Button
            bg='#D3A143'
            color='white'
            fontWeight={400}
            _hover={{ bg: '#c19435' }}
          >
            View More
          </Button>
        <div className='hidden md:block border border-[#F4B41A] w-[30%]'></div>
      </div>

    
    </div>
  );
};

export default Customers;
